// Vendor libraries
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
// Utils
import cloneDeep from 'lodash.clonedeep';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { BULLET_POINT_TOOLBAR_FORMATS, QuillToolbarFormatType, } from 'NewAngular/features/components/modals/text-edit/constants';
// NgRx
import { getCurrentWizardStep, getCurrentWizardStepIndex, getCustomTexts, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { setCustomTexts } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/custom-texts/custom-texts.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
// Components
import { TextEditModalComponent } from 'NewAngular/features/components/modals/text-edit-modal/text-edit-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/text-edit-modal/text-edit-modal.component";
const _c0 = a0 => ({ "show": a0 });
const _c1 = a0 => ({ show: a0 });
function EditCustomTextModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "div", 11)(3, "button", 12);
    i0.ɵɵlistener("click", function EditCustomTextModalComponent_div_7_Template_button_click_3_listener() { const module_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.toggleModuleExpansion(module_r2)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(5, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 15)(7, "div", 16)(8, "div");
    i0.ɵɵelement(9, "p", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 18)(11, "button", 19);
    i0.ɵɵlistener("click", function EditCustomTextModalComponent_div_7_Template_button_click_11_listener() { const module_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.handleEditModule(module_r2)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 20);
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const module_r2 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, module_r2.expanded));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", module_r2.module_title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, module_r2.expanded));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", module_r2.custom_text, i0.ɵɵsanitizeHtml);
} }
/**
 * Edit Custom Text Modal Component
 *
 * Used for editing the Custom Text used for a module in the Custom PDF Reports in the wizard steps
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when the wizard should move to the previous step or next step.
 *
 */
export class EditCustomTextModalComponent {
    constructor(store) {
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.currentWizardStep = null;
        this.modules = [];
        this.customTextsModuleMap = {};
        this.toggleableCustomTextModules = [];
        this.quillFormats = [
            QuillToolbarFormatType.SIZE,
            QuillToolbarFormatType.LINK,
            QuillToolbarFormatType.DATE_EMBED,
            ...BULLET_POINT_TOOLBAR_FORMATS,
        ];
        this.mapStateToComponent = (state) => {
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.currentWizardStep = getCurrentWizardStep(state);
            if (this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_EDIT_CUSTOM_TEXT_MODAL) {
                this.modules = this.currentWizardStep.modules ?? [];
            }
            this.customTextsModuleMap = getCustomTexts(state);
            if (!this.modalOpen &&
                this.currentWizardStepIndex === 0 &&
                this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_EDIT_CUSTOM_TEXT_MODAL) {
                this.openModal();
            }
        };
        this.moduleMapHasModuleData = (module) => {
            return (this.customTextsModuleMap[module.module_type] !== undefined &&
                this.customTextsModuleMap[module.module_type][module.id ?? module.step_uuid] !== undefined);
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        if (!this.isModuleMapFullyPopulated()) {
            const customTextsModuleMap = cloneDeep(this.customTextsModuleMap);
            Object.values(this.modules).forEach((module) => {
                if (!customTextsModuleMap[module.module_type]) {
                    customTextsModuleMap[module.module_type] = {};
                }
                if (!customTextsModuleMap[module.module_type][module.id ?? module.step_uuid]) {
                    customTextsModuleMap[module.module_type][module.id ?? module.step_uuid] = cloneDeep(module);
                }
            });
            this.customTextsModuleMap = customTextsModuleMap;
            this.store.dispatch(setCustomTexts({ customTexts: customTextsModuleMap }));
        }
        // Calculate a flat array of the custom text modules for displaying in the template, with toggleable details
        this.toggleableCustomTextModules = Object.values(this.customTextsModuleMap).flatMap((modules) => Object.values(modules).map((module) => ({ ...module, expanded: false })));
        // Sort according to module location in report.
        this.toggleableCustomTextModules.sort(({ step_uuid: moduleAStepUUID }, { step_uuid: moduleBStepUUID }) => this.modules.findIndex((m) => m.step_uuid === moduleAStepUUID) -
            this.modules.findIndex((m) => m.step_uuid === moduleBStepUUID));
        this.modalOpen = true;
    }
    isModuleMapFullyPopulated() {
        if (!this.modules || this.modules.length === 0) {
            return false;
        }
        return this.modules.every((module) => this.moduleMapHasModuleData(module));
    }
    closeModal() {
        this.modalOpen = false;
        this.toggleableCustomTextModules = [];
    }
    exitModalHandler() {
        this.closeModal();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    forward() {
        this.closeModal();
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
    back() {
        this.closeModal();
        this.store.dispatch(decrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
    handleEditModule(module) {
        this.editingModule = module;
        this.editModal.openModal();
    }
    handleModuleTextSaved(customText) {
        const editingModuleId = this.editingModule.id ?? this.editingModule.step_uuid;
        // Update the flat array of modules with the new custom text
        this.toggleableCustomTextModules = this.toggleableCustomTextModules.map((module) => module.module_type === this.editingModule.module_type && (module.id ?? module.step_uuid) === editingModuleId
            ? { ...module, custom_text: customText }
            : module);
        // Store new custom text in state for usage in generation request and rehydration for wizard navigation
        const customTextsModuleMap = cloneDeep(this.customTextsModuleMap);
        customTextsModuleMap[this.editingModule.module_type][editingModuleId].custom_text = customText;
        this.store.dispatch(setCustomTexts({ customTexts: customTextsModuleMap }));
    }
    toggleModuleExpansion(module) {
        // Toggle the expanded property for the given module
        this.toggleableCustomTextModules = this.toggleableCustomTextModules.map((m) => m.module_type === module.module_type && (m.id ?? m.step_uuid) === (module.id ?? module.step_uuid)
            ? { ...m, expanded: !m.expanded }
            : m);
    }
}
EditCustomTextModalComponent.ɵfac = function EditCustomTextModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditCustomTextModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
EditCustomTextModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EditCustomTextModalComponent, selectors: [["ycn-edit-custom-text-modal"]], viewQuery: function EditCustomTextModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TextEditModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editModal = _t.first);
    } }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 10, vars: 5, consts: [["modalBaseClass", "modal-fix-scroll", 3, "closeModalHandler", "open"], ["header", "Generate Report", 3, "closeModalHandler"], [1, "modal-body"], [1, "modal-section"], [1, "mb-10"], [1, "plates", "pl-20", "pr-20", "pt-20", "pb-10", "bg-panel"], ["class", "plate-container", 4, "ngFor", "ngForOf"], ["modalTestId", "edit-custom-text-modal", "cancelButtonText", "Back", "submitButtonText", "Next", 3, "cancelHandler", "submitHandler"], [3, "textSaved", "extraFormats", "title", "text"], [1, "plate-container"], [1, "plate", "plate-collapsible", "plate-white"], [1, "plate-header"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-toggler", "show", 3, "click", "ngClass"], ["ycnIcon", "", "name", "icon-collapse", 1, "icon-collapse", "fill-current", "text-gray-70"], [1, "plate-title", "align-items-center", "text-bold", "ng-binding", 3, "textContent"], [1, "plate-content", "pr-40", "collapse", "show", 3, "ngClass"], [1, "d-flex"], [3, "innerHTML"], [1, "flex-none", "align-self-end"], [1, "btn", "btn-transparent2", "btn-circle", "btn-xs", "btn-edit-inline", 3, "click"], ["ycnIcon", "", "name", "icon-edit", 1, "icon-edit"]], template: function EditCustomTextModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function EditCustomTextModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function EditCustomTextModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4);
        i0.ɵɵtext(5, " Customize the text in the custom text module(s) or skip this step by clicking next below. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtemplate(7, EditCustomTextModalComponent_div_7_Template, 13, 8, "div", 6);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(8, "ycn-simple-modal-footer", 7);
        i0.ɵɵlistener("cancelHandler", function EditCustomTextModalComponent_Template_ycn_simple_modal_footer_cancelHandler_8_listener() { return ctx.back(); })("submitHandler", function EditCustomTextModalComponent_Template_ycn_simple_modal_footer_submitHandler_8_listener() { return ctx.forward(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "ycn-text-edit-modal", 8);
        i0.ɵɵlistener("textSaved", function EditCustomTextModalComponent_Template_ycn_text_edit_modal_textSaved_9_listener($event) { return ctx.handleModuleTextSaved($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngForOf", ctx.toggleableCustomTextModules);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("extraFormats", ctx.quillFormats)("title", (ctx.editingModule == null ? null : ctx.editingModule.module_title) || "")("text", (ctx.editingModule == null ? null : ctx.editingModule.custom_text) || "");
    } }, dependencies: [i2.NgClass, i2.NgForOf, i3.IconDirective, i4.ModalBaseComponent, i5.SimpleModalFooterComponent, i6.SimpleModalHeaderComponent, i7.TextEditModalComponent], encapsulation: 2 });
